import React from 'react';
import ReactDOM from 'react-dom';
import { LoginRouter } from '@js/routes/index';

ReactDOM.render(<LoginRouter />, document.getElementById('login'));
